module.exports = __webpack_public_path__ + "img/icn-d-pendance.7a3da8cc.svg";